import { FC } from "react";
import { Link } from "react-router-dom";
import { Box, Button, Paper, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/AddOutlined";
import __ from "src/utils/Translations";
import useBasePath from "src/utils/hooks/useBasePath";
import { absencesAbsencesConfigurationWrite } from "src/utils/RoleBasedSecurity/permissions";
import { usePermission } from "src/utils/hooks/permissions/usePermissions";

const CalendarsEmpty: FC = () => {
  const basePath = useBasePath();
  const canWriteAbsencesConfiguration = usePermission(
    absencesAbsencesConfigurationWrite
  );

  return (
    <Paper>
      <Box
        sx={{
          textAlign: "center",
          padding: "2rem",
        }}
      >
        <Typography variant="h5" component="h2" sx={{ mb: "2rem" }}>
          {__("Brak kalendarzy do wyświetlenia")}
        </Typography>
        {canWriteAbsencesConfiguration && (
          <Button
            component={Link}
            variant="contained"
            to={`${basePath}/absences/calendars/create`}
            startIcon={<AddIcon />}
          >
            {__("Dodaj nowy kalendarz")}
          </Button>
        )}
      </Box>
    </Paper>
  );
};

export default CalendarsEmpty;
